export const application = 'bright-preprod';

export const apiURL = '/bright/api';

export const academyURL = 'https://app-preprod.learnwithbright.academy';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
